const state = {
  loading: false,
}

const getters = {
  isLoading: state => state.loading,
}

const actions = {
  setLoading({ commit }, value) {
    commit('setLoading', value)
  },
}

const mutations = {
  setLoading(state, value) {
    state.loading = value
  },
}

export default {
  state,
  actions,
  mutations,
  getters
};